import { buttonIcon } from './BsiIcon';
import { MobileTitle } from './Shared';
import app from 'flarum/forum/app';
import UserPage from 'flarum/forum/components/UserPage';
import UserCard from 'flarum/forum/components/UserCard';
import LinkButton from 'flarum/common/components/LinkButton';
import Button from 'flarum/common/components/Button';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import ChangePasswordModal from './ChangePasswordModal';
import { AuthRequired, ErrorBox } from './Shared';
import { t, text, date, errorText } from '../helpers';
export default class ProfilePage extends UserPage {
  oninit(vnode) {
    super.oninit(vnode);
    this.bodyClass = 'App--bsi';
    this.error = null;
    if (app.session.user) {
      const username = m.route.param('username');
      if (username) this.loadUser(username).catch(error => {
        this.error = errorText(error);
        m.redraw();
      });else this.show(app.session.user);
    }
    app.setTitle(text('nav.profile'));
  }
  view() {
    if (!app.session.user) return m("div", {
      className: "BsiPage"
    }, m(MobileTitle, null), m("div", {
      className: "container"
    }, m(AuthRequired, null)));
    if (this.error) return m("div", {
      className: "BsiPage"
    }, m(MobileTitle, null), m("div", {
      className: "container"
    }, m(ErrorBox, {
      error: this.error
    })));
    if (!this.user) return m(LoadingIndicator, {
      display: "block"
    });
    const isSelf = this.user.id() === app.session.user.id();
    return m("div", {
      className: "BsiPage BsiProfile"
    }, m(MobileTitle, null), m(UserCard, {
      user: this.user,
      className: "Hero UserHero",
      editable: isSelf || this.user.canEdit(),
      controlsButtonClassName: "Button"
    }), m("div", {
      className: "container"
    }, m("section", {
      className: "BsiPanel"
    }, m("h2", null, t('profile.account')), m("dl", {
      className: "BsiDetails"
    }, m("div", null, m("dt", null, t('profile.username')), m("dd", null, this.user.username())), isSelf && m("div", null, m("dt", null, t('contacts.email')), m("dd", null, this.user.email())), m("div", null, m("dt", null, t('profile.registered')), m("dd", null, date(this.user.joinTime())))), isSelf && m("div", null, m("div", {
      className: "BsiActions"
    }, m(LinkButton, {
      className: "Button",
      href: app.route('bsi.orders'),
      icon: buttonIcon('folders')
    }, t('nav.orders')), m(LinkButton, {
      className: "Button",
      href: app.route('settings'),
      icon: buttonIcon('gear')
    }, t('profile.settings')), m(Button, {
      className: "Button",
      icon: buttonIcon('lock-key'),
      onclick: () => app.modal.show(ChangePasswordModal)
    }, t('profile.change_password')))))));
  }
}
flarum.reg.add('bsi-orders', 'forum/components/ProfilePage', ProfilePage);